import { Box } from '@mui/material';

const ZONE_PALETTE = {
    LOCAL:    { bg: '#dbeafe', fg: '#1d4ed8' },
    REGIONAL: { bg: '#e0e7ff', fg: '#4338ca' },
    METROS:   { bg: '#fce7f3', fg: '#be185d' },
    ROI:      { bg: '#d1fae5', fg: '#065f46' },
    SPECIAL:  { bg: '#fef3c7', fg: '#92400e' },
};

/**
 * Compact zone badge — colour-coded by zone name.
 *
 * Props:
 *   zone  string  — zone name (e.g. 'LOCAL', 'REGIONAL', 'ROI')
 */
export default function ZoneBadge({ zone }) {
    if (!zone) return <Box sx={{ fontSize: '12px', color: 'text.disabled' }}>—</Box>;
    const p = ZONE_PALETTE[zone.toUpperCase()] || { bg: '#f3f4f6', fg: '#374151' };
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: '7px',
                py: '2px',
                borderRadius: '4px',
                fontSize: '10px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                bgcolor: p.bg,
                color: p.fg,
            }}
        >
            {zone}
        </Box>
    );
}
